import React, { useEffect, useState } from 'react';
import styles from './StyleSelector.module.scss';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';

const StyleSelector = ({
  title = 'Style',
  options = [],
  value,
  onChange,
  defaultIndex = 0,
}) => {
  const safeOptions =
    options.length > 0
      ? options
      : [
          { type: 'gradientStyle', value: 'gradient' },
          { type: 'basicStyle', value: 'basic' },
        ];

  const [selectedIndex, setSelectedIndex] = useState(
    Math.min(Math.max(defaultIndex, 0), safeOptions.length - 1)
  );

  const controlledIndex =
    typeof value !== 'undefined'
      ? Math.max(
          0,
          safeOptions.findIndex((o) => (o.value ?? o.type) === value)
        )
      : null;

  const activeIndex =
    controlledIndex !== null && controlledIndex !== -1
      ? controlledIndex
      : selectedIndex;

  useEffect(() => {
    if (activeIndex >= safeOptions.length) {
      setSelectedIndex(0);
    }
  }, [safeOptions.length, activeIndex]);

  const handleSelect = (idx) => {
    const opt = safeOptions[idx];
    const val = opt.value ?? opt.type;
    if (typeof value === 'undefined') {
      setSelectedIndex(idx);
    }
    onChange?.(val, idx);
  };

  return (
    <div className={styles['style-selector']}>
      <p className={styles['input-title']}>{title}</p>
      <div className={styles['style-options']}>
        {safeOptions.map((opt, i) => {
          const isActive = i === activeIndex;
          return (
            <div
              key={i}
              className={`${styles['style-option']} ${
                isActive ? styles['is-selected'] : ''
              }`}
            >
              <SvgWithBranding
                type={opt.type}
                className={`${styles['style-svg']} ${
                  isActive ? styles['selected'] : ''
                }`}
                onClick={() => handleSelect(i)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') handleSelect(i);
                }}
              />
              <div
                className={`${styles['strip']} ${
                  isActive ? styles['stripActive'] : ''
                }`}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default StyleSelector;
